import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectProductSearchResult} from 'coreStore/data/productSearchResult';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useSearchMgr custom hook
 */
export default function useSearchMgr() {
	const {managerRepository} = useGeneralProvider();

	const searchResult = useSelector((state) => selectProductSearchResult(state));

	// A new object per search result: the instances read it (and the React Compiler memoizes on this reference).
	return useMemo(
		() => ({getInstance: (key: string = undefined) => managerRepository.getSearchMgr().getInstance(key)}),
		[managerRepository, searchResult],
	);
};
